import React from 'react';
import {
  Button, Popup,
} from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

const CopyButton = ({ value, message = 'actions.copy.clipboard' }) => {
  const intl = useIntl();
  return (
    <Popup
      content={intl.formatMessage({ id: message })}
      trigger={(
        <CopyToClipboard text={value}>
          <Button icon="copy outline" />
        </CopyToClipboard>
            )}
    />
  );
};

export default CopyButton;
